var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h5-page" },
    [
      _c("div", { staticClass: "h5-header" }, [_vm._v("我的订单")]),
      _c(
        "div",
        { staticClass: "status-bar" },
        _vm._l(_vm.statusMap, function (name, status) {
          return _c(
            "span",
            {
              key: status,
              staticClass: "status-tag",
              class: { on: _vm.queryStatus === status },
              on: {
                click: function ($event) {
                  return _vm.switchStatus(status)
                },
              },
            },
            [_vm._v(_vm._s(name))]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "h5-body" },
        [
          _vm._l(_vm.orders, function (order) {
            return _c(
              "div",
              {
                key: order.id,
                staticClass: "h5-card",
                on: {
                  click: function ($event) {
                    return _vm.goDetail(order)
                  },
                },
              },
              [
                _c("div", { staticClass: "order-row" }, [
                  _c("span", { staticClass: "order-no" }, [
                    _vm._v(_vm._s(order.billNo)),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "order-status",
                      style: { color: _vm.statusColor[order.orderStatus] },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          order.orderStatusName ||
                            _vm.statusMap[order.orderStatus]
                        )
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "order-row sub" }, [
                  _c("span", [
                    _vm._v("伙伴：" + _vm._s(order.partnerName || "-")),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(order.subType === "采购订单" ? "采购" : "销售") +
                        " · " +
                        _vm._s(
                          _vm.sourceMap[order.sourceType] || order.sourceType
                        )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "order-row sub" }, [
                  _c("span", [
                    _vm._v(
                      "金额：￥" + _vm._s(_vm.formatAmount(order.totalPrice))
                    ),
                  ]),
                  _c("span", [_vm._v(_vm._s(order.operTime))]),
                ]),
              ]
            )
          }),
          !_vm.loading && _vm.orders.length === 0
            ? _c("div", { staticClass: "empty" }, [_vm._v("暂无订单")])
            : _vm._e(),
          _vm.hasMore && !_vm.loading
            ? _c(
                "a-button",
                { attrs: { block: "" }, on: { click: _vm.loadOrders } },
                [_vm._v("加载更多")]
              )
            : _vm._e(),
        ],
        2
      ),
      _c("h5-tab-bar", { attrs: { active: "orders" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }